import React, { Component } from 'react';
import './../stylesheets/general.css';
import { Link } from 'react-router-dom';
import posed from 'react-pose';
import TopLogo from './TopLogo';
import MetaTagsComponent from './MetaTagsComponent';

const Box = posed.div({
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  pressable: true,
  press: { scale: 0.8 },
  init: { scale: 1 },
  hoverable: true,
  hover: { scale: 1.2 }
});

const Title = posed.h1({
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
});

class Games extends Component {
  state = { title: false }

  componentDidMount() {
    this.titleTimer = setTimeout(() => {
      this.setState({ title: true });
    }, 600);
    this.capsnspoonsTimer = setTimeout(() => {
      this.setState({ capsnspoons: true });
    }, 1200);
      this.mechacapTimer = setTimeout(() => {
      this.setState({ mechacap: true });
    }, 1400);
    this.umbrellagirlTimer = setTimeout(() => {
      this.setState({ umbrellagirl: true });
    }, 1600);
    this.tapocketaTimer = setTimeout(() => {
      this.setState({ tapocketa: true });
    }, 1800);
    this.mauaTimer = setTimeout(() => {
      this.setState({ maua: true });
    }, 2000);
    this.goBackTimer = setTimeout(() => {
      this.setState({ goBack: true });
    }, 2200);
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    clearTimeout(this.titleTimer);
    clearTimeout(this.capsnspoonsTimer);
    clearTimeout(this.mechacapTimer);
    clearTimeout(this.umbrellagirlTimer);
    clearTimeout(this.tapocketaTimer);
    clearTimeout(this.mauaTimer);
    clearTimeout(this.goBackTimer);
  }

  render() {
    const { title } = this.state;
    const { umbrellagirl } = this.state;
    const { tapocketa } = this.state;
    const { maua } = this.state;
    const { mechacap } = this.state;
    const { capsnspoons } = this.state;
    const { goBack } = this.state;

    return (
      <section className="games">
        <MetaTagsComponent />

        <TopLogo />
        <Title className="box" pose={title ? 'visible' : 'hidden'}>
          Our Games
                </Title>

        <div className="main-menu">
          <ul>
            <Box className="box" pose={capsnspoons ? 'visible' : 'hidden'}>
              <li><a  href="https://store.steampowered.com/app/4414140/Caps__Spoons__Fungerellian_Foodery_Simulator/">
                <h2>Caps & Spoons</h2>
              </a></li>
            </Box>
            <Box className="box" pose={mechacap ? 'visible' : 'hidden'}>
              <li><a  href="https://store.steampowered.com/app/4376040/MechaCap_Arena/">
                <h2>MechaCap Arena</h2>
              </a></li>
            </Box>
            <Box className="box" pose={umbrellagirl ? 'visible' : 'hidden'}>
              <li><Link to="/umbrellagirl">
                <h2>Umbrellagirl</h2>
              </Link></li>
            </Box>
            <Box className="box" pose={tapocketa ? 'visible' : 'hidden'}>
              <li><Link to="/tapocketa">
                <h2>Tapocketa</h2>
              </Link></li>
            </Box>
            <Box className="box" pose={maua ? 'visible' : 'hidden'}>
              <li><Link to="/maua">
                <h2>Maua</h2>
              </Link></li>
            </Box>
            <Box className="box" pose={goBack ? 'visible' : 'hidden'}>
              <li><Link to="/">
                <div className="go-back-button">
                  <h3>&lt; Go back</h3>
                </div>
              </Link></li>
            </Box>
          </ul>
        </div>
      </section>
    );
  }
}

export default Games;